import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Tablehead } from "../../components/common/modules/Tablehead";
// import { posrepairorder_head } from "../../components/common/Tablehead";
import { SetdataTable, UnSetdataTable } from "../common/api/setdatatable";
import { _Api } from "../common/api/_call";
import $ from "jquery";
import { toFormatPrice, toUnformatPrice } from "../common/helpers/function";
import "../Custom/custom.scss";
import CustomerSearchModal from "../common/module/customerSearch";
import TableColumnModal from "../../components/common/modules/tableColumn";
import TableLoader from "../../admin/common/TableLoader";
import { store } from "../../source/index";
import { updateWarrantyPOS } from "source/app/appSlice";
import optionIcon from "../../assets/images/icons/optionButton.png";
import "./GiftCard.scss";
import Loading from "pos/common/module/Loading/Loading";

const posrepairorder_head = [
  {
    lable: "check_box",
    name: "check_box",
    class: "gisClassTh_main pos_repairorderhead",
    sort: 0,
    status: true,
  },
  { lable: "#", name: "#", class: "fixed-side", sort: 0, status: true },
  { lable: "Image", name: "Image", class: "fixed-side", status: true, sort: 0 },
  { lable: "Date", name: "Date", class: "", sort: 1, status: true },
  { lable: "Ref No.", name: "Ref.No", class: "", sort: 1, status: true },
  { lable: "SKU", name: "SKU", class: "", sort: 1, status: true },
  { lable: "", name: "", class: "", sort: 0, status: true },
  { lable: "Metal", name: "Metal", class: "", sort: 1, status: true },
  { lable: "Stone", name: "Stone", class: "", sort: 1, status: true },
  { lable: "Size", name: "Size", class: "", sort: 1, status: true },
  { lable: "Stock ID", name: "Stock ID", class: "", sort: 1, status: true },
  { lable: "Location", name: "Location", class: "", status: true, sort: 1 },
  { lable: "Qty", name: "Qty", class: "lightgray", status: true, sort: 1 },
  { lable: "Amount", name: "Amount", class: "", status: true, sort: 1 },
];

const WarrantyCardOrderList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const reduxdata = store.getState();
  const OrgSettings = reduxdata?.app?.posorganisation_settings;
  const customer = useSelector((state) => state.app.customer);
  const fullOrderRef = useRef([]);
  const [isOptionClick, setIsOptionClick] = useState(false);

  const [newcolumndata, setnewcolumndata] = useState(posrepairorder_head);
  const [, setfilterby] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [TransactionDate, setTransactionDate] = useState();
  const [dataloder, setDataloder] = useState(false);

  const selectTransactionDate = (input) => {
    setTransactionDate(input);
  };

  useEffect(() => {
    callcolumns();
  }, []);

  const callcolumns = async () => {
    try {
      const postdata = { name: "tbl_pos_warranty_order" };
      const columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const destroyDataTable = () => {
    if ($.fn.DataTable.isDataTable("#com-data-area_table")) {
      $("#com-data-area_table").DataTable().destroy();
    }
  };

  const initDataTable = () => {
    try {
      UnSetdataTable("com-data-area_table");
    } catch (e) {
      destroyDataTable();
    }
    SetdataTable("com-data-area_table", 4, newcolumndata, 0);
  };

  const getPurchaseHistory = async () => {
    if (!customer?.id) {
      setOrderData([]);
      setSelectedId("");
      return;
    }
    try {
      setDataloder(true);
      const postdata = {
        date: TransactionDate,
        customer_id: customer?.id,
      };
      const res = await _Api(postdata, `api/v1/POS/repair/getSalesOrderListWarranty`);
      if (res?.code === 200) {
        setOrderData(res?.data || []);
        fullOrderRef.current = res?.data;
        setSelectedId("");
      } else {
        setOrderData([]);
      }
      setDataloder(false);
      setTimeout(() => initDataTable(), 200);
    } catch (err) {
      console.log(err, "err");
      setDataloder(false);
    }
  };

  useEffect(() => {
    if (customer?.id) {
      getPurchaseHistory();
    }
    // eslint-disable-next-line
  }, [customer?.id, TransactionDate]);

  useEffect(() => {
    if (isOptionClick) {
      setOrderData(
        fullOrderRef.current.filter((i) => i.warranty_print === true),
      );
    } else {
      setOrderData(fullOrderRef.current);
    }
  }, [isOptionClick]);

  useEffect(() => () => destroyDataTable(), []);

  const totalQty = orderData?.length
    ? orderData.reduce((sum, row) => sum + (Number(row?.Qty) || 0), 0)
    : 0;

  const totalAmount = orderData?.length
    ? orderData.reduce((sum, row) => sum + toUnformatPrice(row?.amount), 0)
    : 0;
 const location = useLocation();
const [showLoading, setShowLoading] = useState(location.state?.fromClick ?? false);

useEffect(() => {
  if (!showLoading) return;
  const timer = setTimeout(() => setShowLoading(false), 1500);
  return () => clearTimeout(timer);
}, []);

if (showLoading) return <Loading />;
  return (
    <>
      <div className="main-body wc-order-list">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="com-data-area">
              <h2
                className="wc-order-list__page-title"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  paddingTop: 20,
                }}
              >
                <Link
                  to="/app/pos/warrantyCard"
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#A4A4A4",
                  }}
                >
                  {t("Warranty Card")}
                </Link>
                <div>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.92098 14.0071C4.99838 14.0847 5.09034 14.1463 5.19159 14.1883C5.29283 14.2303 5.40136 14.252 5.51098 14.252C5.62059 14.252 5.72912 14.2303 5.83037 14.1883C5.93161 14.1463 6.02357 14.0847 6.10098 14.0071L11.641 8.46713C11.7028 8.40546 11.7518 8.3322 11.7853 8.25155C11.8187 8.1709 11.8359 8.08444 11.8359 7.99713C11.8359 7.90982 11.8187 7.82336 11.7853 7.74271C11.7518 7.66207 11.7028 7.58881 11.641 7.52713L6.10097 1.98713C5.77431 1.66046 5.24764 1.66046 4.92097 1.98713C4.59431 2.3138 4.59431 2.84046 4.92097 3.16713L9.74764 8.00046L4.91431 12.8338C4.59431 13.1538 4.59431 13.6871 4.92098 14.0071Z"
                      fill="#2A2A2A"
                    />
                  </svg>
                </div>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#2A2A2A",
                  }}
                >
                  {t("Purchased History")}
                </span>
              </h2>

              <div className="com-data-area-header delivered-header">
                <div className="delivered-header-left custom-order-search">
                  <CustomerSearchModal warranty={true}/>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    alignItems: "center",
                    marginLeft: "auto",
                  }}
                >
                  <div
                    className="tooltip-area-up"
                    style={{ width: "auto", height: "auto" }}
                  >
                    <div
                      className="inventory-btn"
                      style={{
                        display: "flex",
                        gap: "3px",
                        fontSize: "14px",
                        alignItems: "center",
                        background: isOptionClick ? "#D8F3F2" : "transparent",
                        border: isOptionClick ? "1px solid #62D0CB" : "unset",
                        padding: isOptionClick ? "0px 12px" : "unset",
                      }}
                      onClick={() => setIsOptionClick(!isOptionClick)}
                    >
                      <img
                        src={optionIcon}
                        alt="logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                      />
                      {isOptionClick
                        ? fullOrderRef.current.filter(
                            (i) => i.warranty_print === true,
                          )?.length
                        : undefined}
                    </div>
                    <span className="tooltip-area-up-text">Reprint Filter</span>
                  </div>
                  <div className="placeholder-up-input-date date wc-order-list__date-picker">
                    <DatePicker
                      className="placeholder-up-input-field"
                      placeholderText="MM-DD-YYYY"
                      selected={TransactionDate}
                      onChange={selectTransactionDate}
                      name="TransactionDate"
                      dateFormat={OrgSettings?.date_picker}
                      autoComplete="none"
                    />
                    <img
                      className="placeholder-up-input-field-calender"
                      src={base_assets + "images/icons/calendar-green.svg"}
                      alt=""
                    />
                  </div>
                  <div className="dropdown Dailysalereport-content-area-header-leftdropdown">
                    <button
                      className="btn-style"
                      type="button"
                      id="wcOrderListMenu"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + "images/icons/ellipsis-circular.png"}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu Dailysalereport-content-area-header-leftdropdown-menu"
                      aria-labelledby="wcOrderListMenu"
                    >
                      <li>
                        <Link
                          className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                          to="#"
                        >
                          <div className="dropdown-menu-img">
                            <img
                              src={
                                base_assets + "images/pos/report/print-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          {t("Print")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                          to="#"
                        >
                          <div className="dropdown-menu-img">
                            <img
                              src={
                                base_assets +
                                "images/pos/report/export-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          {t("Export")}
                        </Link>
                      </li>
                      <li data-bs-toggle="modal" data-bs-target="#columnModal">
                        <Link
                          className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                          to="#"
                        >
                          <div className="dropdown-menu-img">
                            <img
                              src={base_assets + "images/icons/column-icon.png"}
                              alt=""
                            />
                          </div>
                          {t("Column")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="wc-order-list__body"
                style={{ padding: "0 1.92vw" }}
              >
                <div className="com-data-area-inner overflow-auto wc-order-list__table-wrap p-0">
                  <div
                    className="main-body-main-table-wrap overflow-auto vertical-scroll-table position-relative"
                    id="table-scroll"
                  >
                    <table
                      id="com-data-area_table"
                      className="common-table first-row-gray w-100"
                    >
                      <Tablehead
                        tablehead={posrepairorder_head}
                        tblName={"tbl_pos_warranty_order"}
                        setfilterby={setfilterby}
                      />
                      <tbody>
                        {orderData?.length
                          ? orderData.map((result, key) => (
                              <tr
                                key={result?.cart_id || key}
                                className={
                                  String(selectedId) === String(result?.cart_id)
                                    ? "wc-order-list__row--selected"
                                    : ""
                                }
                              >
                                <td className="row-check">
                                  <div className="com-check radio">
                                    <input
                                      type="radio"
                                      name="warranty-purchase-select"
                                      id={`wc-${result?.cart_id}`}
                                      checked={
                                        String(selectedId) ===
                                        String(result?.cart_id)
                                      }
                                      onChange={() => {
                                        setSelectedId(result?.cart_id);
                                        dispatch(updateWarrantyPOS(result));
                                      }}
                                    />
                                    <label
                                      htmlFor={`wc-${result?.cart_id}`}
                                      className="com-check-label"
                                    />
                                  </div>
                                </td>
                                <td>{key + 1}</td>
                                <td>
                                  <div className="pro-img">
                                    <img src={result?.image} alt="" />
                                  </div>
                                </td>
                                <td>{result?.date}</td>
                                <td className="link-color">{result?.ref_no}</td>
                                <td className="link-color">{result?.SKU}</td>
                                <td>
                                  {" "}
                                  {result?.warranty_print ? (
                                    <div
                                      className="tooltip-area-up"
                                      style={{ width: "auto", height: "auto" }}
                                    >
                                      <img
                                        src={optionIcon}
                                        alt="logo"
                                        style={{
                                          // width: "100%",
                                          // height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                      {result?.warranty_print && (
                                        <span className="tooltip-area-up-text">
                                          {result?.warranty_print
                                            ? t("Reprint")
                                            : ""}
                                        </span>
                                      )}
                                    </div>
                                  ) : null}
                                </td>
                                <td>{result?.metal_name}</td>
                                <td>{result?.stone_name}</td>
                                <td>{result?.size_name}</td>
                                <td>{result?.stock_id}</td>
                                <td>{result?.location}</td>
                                <td>{result?.Qty}</td>
                                <td>
                                  {toFormatPrice(result?.amount, {
                                    addSymbol: true,
                                  })}
                                </td>
                              </tr>
                            ))
                          : <tr><td colSpan={14}><span style={{padding:'5px',fontSize:'14px',textAlign:'center'}}>No Data Found</span></td></tr>}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{orderData?.length ? totalQty : ""}</td>
                          <td>
                            {orderData?.length
                              ? toFormatPrice(totalAmount, { addSymbol: true })
                              : ""}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    {dataloder ? <TableLoader /> : null}
                  </div>
                </div>
                <div className="wc-order-list__footer">
                  <button
                    type="button"
                    className="wc-order-list__submit-btn"
                    disabled={!selectedId}
                    onClick={() => navigate("/app/pos/warrantyCard")}
                  >
                    {t("Button")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col" aria-hidden="true" />
        </div>
      </div>

      <TableColumnModal
        tablehead={posrepairorder_head}
        tblName={"tbl_pos_warranty_order"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={getPurchaseHistory}
      />
    </>
  );
};

export default WarrantyCardOrderList;
